export const TRANSLATION_BASE_URL = '/translation';
